import React, { Component } from 'react';
import i18n from '@i18next/i18n';
import Slider from '@tencent/dui-mobile/lib/components/Slider';
import Divider from '@tencent/dui-mobile/lib/components/Divider';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import styles from './index.css';
import { ITextEditItemsData } from './textEditDataProcesser';
import classNames from 'classnames';
import { MenuType } from '@src/slide/domain/ui-model/constant/menu';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';

interface IEditPanelProps {
    textEditData: ITextEditItemsData;
    menuManager?: IMenuManager;
}
interface IEditPanelStates {
    fontSize: string;
}
const DefaultFontSize = '8';

export default class FontSizeItem extends Component<IEditPanelProps, IEditPanelStates> {
    private timer: NodeJS.Timeout | null;
    private settingFontsize: string;
    private downFontRef: HTMLSpanElement | null;
    private upFontRef: HTMLSpanElement | null;
    public constructor(props) {
        super(props);
        this.state = {
            fontSize: DefaultFontSize,
        };
    }

    // eslint-disable-next-line react/no-deprecated
    public componentWillReceiveProps(nextProps) {
        const fontSize = this.getFontSize(nextProps);
        if (fontSize !== this.settingFontsize) {
            this.setFontSizeState(nextProps);
        }
    }

    public componentDidMount() {
        this.setFontSizeState(this.props);
        // 避免移动端touch和mouse事件重复触发
        if (this.downFontRef) {
            this.downFontRef.addEventListener('touchstart', this.downFontSize, { passive: false });
        }
        if (this.upFontRef) {
            this.upFontRef.addEventListener('touchstart', this.upFontSize, { passive: false });
        }
    }

    public setFontSizeState = (props) => {
        const fontSize = this.getFontSize(props);
        if (fontSize !== this.state.fontSize) {
            this.setState({
                fontSize,
            });
            this.settingFontsize = fontSize.toString();
        }
    };

    public render() {
        if (!this.props.textEditData?.editFontItemsData) {
            return null;
        }
        const cls = classNames({
            [styles['font-size-container']]: true,
            [styles['font-size-container-disable']]: this.isSliderDisable(),
        });
        return <div className={cls}>
            <div className={styles['font-size-container-top']}>
                <span className={styles['font-size-title']}>{i18n.t('字号 {0} pt', { 0: this.state.fontSize })}</span>
                <span className={styles['font-size-button-container']}>
                    <span
                        className={styles['font-size-button-left']}
                        ref={(el) => {
                            this.downFontRef = el;
                        }}
                        onMouseDown={this.downFontSize}>
                    </span>
                    <span
                        className={styles['font-size-button-right']}
                        ref={(el) => {
                            this.upFontRef = el;
                        }}
                        onMouseDown={this.upFontSize}>
                    </span>
                </span>
            </div>
            <Divider
                key={'divider'}
                orientation="horizontal"
                style={{
                    verticalAlign: 'middle',
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    opacity: 0.82,
                }}
            />
            <Slider
                value={Number(this.state.fontSize.match(/\d+\.?\d?/)?.[0])}
                min={8}
                max={192}
                step={4}
                onChange={this.setFontSize}
                style={{ width: '100%', margin: 0 }}
            />
        </div>;
    }

    public upFontSize = (e) => {
        if (this.isUpSizeDisable()) return;
        const nextFontSize = Number(this.state.fontSize.match(/\d+\.?\d?/)?.[0]) + 4;
        this.setState({
            fontSize: (nextFontSize <= 192 ? nextFontSize : 192).toString(),
        });
        this.updateUI(MenuType.TOOLBAR, ActionType.FONTSIZE_UP, {
            max: 192,
            size: 4,
        });
        e.preventDefault();
    };

    public downFontSize = (e) => {
        if (this.isDownSizeDisable()) return;
        const nextFontSize = Number(this.state.fontSize.match(/\d+\.?\d?/)?.[0]) - 4;
        this.setState({
            fontSize: (nextFontSize >= 8 ? nextFontSize : 8).toString(),
        });
        this.updateUI(MenuType.TOOLBAR, ActionType.FONTSIZE_DOWN, {
            min: 8,
            size: -4,
        });
        e.preventDefault();
    };
    private setFontSize = (num) => {
        if (this.isSliderDisable()) return;
        this.setState({
            fontSize: num.toString(),
        });
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        this.timer = setTimeout(() => {
            this.settingFontsize = num.toString();
            const id = this.props.textEditData?.editFontSize?.[0]?.id;
            this.updateUI(MenuType.TOOLBAR, id, `font-size-${num}pt`);
        }, 200);
    };

    private getFontSize = (props) => {
        const { textEditData } = props;
        const fontSizeStr = textEditData.editFontSize?.[0]?.value || DefaultFontSize;
        return fontSizeStr.match(/\d+\.?\d?\+?/)[0];
    };

    private isUpSizeDisable = () => this.props.textEditData.editFontSize?.[0]?.disabled;
    private isDownSizeDisable = () => this.props.textEditData.editFontSize?.[1]?.disabled;
    private isSliderDisable = () => this.isUpSizeDisable() && this.isDownSizeDisable();

    private updateUI = (id, type, value) => {
        const callback = this.props.menuManager?.stylePanelMenu().callback;
        callback?.(id, type, value, undefined);
    };
}
